var map = {
	"./MovesChs.js": [
		5198,
		[
			198
		]
	],
	"./MovesCht.js": [
		9407,
		[
			407
		]
	],
	"./MovesEn.js": [
		4559,
		[]
	],
	"./MovesEs.js": [
		9340,
		[]
	],
	"./MovesEsLa.js": [
		1471,
		[]
	],
	"./MovesFre.js": [
		917,
		[]
	],
	"./MovesGer.js": [
		7972,
		[]
	],
	"./MovesIta.js": [
		1269,
		[]
	],
	"./MovesJpn.js": [
		9826,
		[
			826
		]
	],
	"./MovesKor.js": [
		3498,
		[
			498
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 8460;
module.exports = webpackAsyncContext;